import INITIAL_VALUES from '@app/constants/editingDocumentsFilterInitialValues';
import {
  EDITING_DOCUMENTS_DOMAIN_DATA_INITIALIZE,
  EDITING_DOCUMENTS_LIST_FETCH_SUCCESS,
} from '@app/store/actionTypes';
import { EditingDocumentsAction } from '@app/store/editingDocuments/actions';

type EditingDocumentsOffsetState = number;

const initialState: EditingDocumentsOffsetState = INITIAL_VALUES.offset;

export default function reducer(
  state: EditingDocumentsOffsetState = initialState,
  action: EditingDocumentsAction
) {
  switch (action.type) {
    case EDITING_DOCUMENTS_DOMAIN_DATA_INITIALIZE:
      return initialState;
    case EDITING_DOCUMENTS_LIST_FETCH_SUCCESS:
      return action.payload.offset;
    default:
      return state;
  }
}
